import { environment } from '@env/environment';
import { ApplicationConfig, inject, provideAppInitializer } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideCore } from '@core';
import { appRoutes } from '@app/app.routes';
import { provideCoreRouteReuseStrategy } from '@core/core.route-reuse-strategy';
import { BrightnessService, ConfigService } from '@app/services';

export const appConfig: ApplicationConfig = {
  providers: [
    provideCore({
      id: 'oongalee.lumen',
      name: 'Oongalee Lumen',
      environment: environment.machineName,
      debug: environment.debug,
      authPagePath: 'auth',
      mainPagePath: 'main',
      api: {
        baseUrl: environment.apiUrl,
      },
      websocket: {
        baseUrl: environment.socketApi,
      },
      featureToggle: environment.featureToggle,
      backgroundPlayer: {
        url: environment.backgroundPlayer,
        ad: {
          url: environment.backgroundAdPlayer,
          color: environment.backgroundAdPlayerColor,
        },
      },
      sentry: {
        dsn: environment.sentry.dsn,
        environment: environment.machineName,
      },
      update: {
        checkStrategy: environment.update.checkStrategy,
        activateStrategy: environment.update.activateStrategy,
      },
      serviceWorker: {
        enabled: environment.serviceWorker,
      },
      routes: appRoutes,
    }),
    provideAppInitializer(() => {
      inject(ConfigService).initialize();
      inject(BrightnessService).initialize();
    }),
    provideCoreRouteReuseStrategy(),
    provideAnimations(),
  ],
};
